import { useApiKeys } from './use-api-keys';
import { hasExpiringApiKeys } from './helpers';

/**
 * Are any of the user's (v1) api keys expiring in the coming 30 days
 * @returns {boolean}
 */
export const useHasExpiringApiKeys = () => {
  const { v1ApiKeys } = useApiKeys();
  const result = hasExpiringApiKeys(v1ApiKeys);
  return result;
};
